'use client';

import { Swiper, SwiperSlide } from 'swiper/react';
import { Autoplay } from 'swiper/modules';

const Alerts = ({ data, locale }) => {
  return (
    <div className='flex items-center justify-center text-center'>
      <Swiper
        modules={[Autoplay]}
        loop
        autoplay={{ delay: 2500 }}
        direction='vertical'
        className='top-header-swiper'
      >
        {data
          ?.filter((itemF) => itemF?.active)
          ?.map((info, idx) => (
            <SwiperSlide key={info + idx}>
              <span className='text-center text-xs uppercase'>
                {info?.[`title-${locale}`]}
              </span>
            </SwiperSlide>
          ))}
      </Swiper>
    </div>
  );
};

export default Alerts;
